import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import StudentDashboard from './pages/StudentDashboard';
import SubmitGoalPage from './pages/SubmitGoalPage';
import SubmitCompletionPage from './pages/SubmitCompletionPage';
import StudentAchievementsPage from './pages/StudentAchievementsPage';
import TeacherDashboard from './pages/TeacherDashboard';
import ReviewSubmissionsPage from './pages/ReviewSubmissionsPage';
import AwardBadgesPage from './pages/AwardBadgesPage';
import LoginPage from './pages/LoginPage';
export function App() {
  // Use localStorage to persist authentication state
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem('isAuthenticated') === 'true';
  });
  // Track user role (student or teacher)
  const [userRole, setUserRole] = useState(() => {
    return localStorage.getItem('userRole') || 'student';
  });
  const handleLogin = (role = 'student') => {
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('userRole', role);
    setIsAuthenticated(true);
    setUserRole(role);
  };
  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userRole');
    setIsAuthenticated(false);
    setUserRole('student');
  };
  // Protected route component
  const ProtectedRoute = ({
    children,
    requiredRole
  }: {
    children: React.ReactNode;
    requiredRole?: string;
  }) => {
    if (!isAuthenticated) {
      return <Navigate to="/login" replace data-id="element-0" />;
    }
    if (requiredRole && userRole !== requiredRole) {
      return <Navigate to="/" replace data-id="element-1" />;
    }
    return <>{children}</>;
  };
  return <>
      <Routes data-id="element-2">
        {/* Public routes */}
        <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace data-id="element-4" /> : <LoginPage onLogin={handleLogin} data-id="element-5" />} data-id="element-3" />
        {/* Student routes */}
        <Route path="/" element={<ProtectedRoute data-id="element-7">
              <Layout onLogout={handleLogout} userRole={userRole} data-id="element-8">
                {userRole === 'teacher' ? <TeacherDashboard data-id="element-9" /> : <StudentDashboard data-id="element-10" />}
              </Layout>
            </ProtectedRoute>} data-id="element-6" />
        <Route path="/submit-goal" element={<ProtectedRoute requiredRole="student" data-id="element-12">
              <Layout onLogout={handleLogout} userRole={userRole} data-id="element-13">
                <SubmitGoalPage data-id="element-14" />
              </Layout>
            </ProtectedRoute>} data-id="element-11" />
        <Route path="/submit-completion/:goalId" element={<ProtectedRoute requiredRole="student" data-id="element-16">
              <Layout onLogout={handleLogout} userRole={userRole} data-id="element-17">
                <SubmitCompletionPage data-id="element-18" />
              </Layout>
            </ProtectedRoute>} data-id="element-15" />
        <Route path="/achievements" element={<ProtectedRoute requiredRole="student" data-id="element-20">
              <Layout onLogout={handleLogout} userRole={userRole} data-id="element-21">
                <StudentAchievementsPage data-id="element-22" />
              </Layout>
            </ProtectedRoute>} data-id="element-19" />
        {/* Teacher routes */}
        <Route path="/review-submissions" element={<ProtectedRoute requiredRole="teacher" data-id="element-24">
              <Layout onLogout={handleLogout} userRole={userRole} data-id="element-25">
                <ReviewSubmissionsPage data-id="element-26" />
              </Layout>
            </ProtectedRoute>} data-id="element-23" />
        <Route path="/award-badges" element={<ProtectedRoute requiredRole="teacher" data-id="element-28">
              <Layout onLogout={handleLogout} userRole={userRole} data-id="element-29">
                <AwardBadgesPage data-id="element-30" />
              </Layout>
            </ProtectedRoute>} data-id="element-27" />
        {/* Fallback route */}
        <Route path="*" element={isAuthenticated ? <Navigate to="/" replace data-id="element-32" /> : <Navigate to="/login" replace data-id="element-33" />} data-id="element-31" />
      </Routes>
    </>;
}